import { useQuery } from '@tanstack/react-query';
import { getTeams } from 'api/teams';
import { teamsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useTeamsQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: teamsKeys.list(companyId),
    queryFn: () => getTeams().then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
